/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiControlShared.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-control-shared";

export class AutogenModelEdiControlShared<RowType extends ModelRow> extends Endpoint<RowType, RowEdiControlSharedFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiControlShared extends ModelRow<RowEdiControlSharedFields> {
	constructor(values?: Partial<RowEdiControlSharedFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiControlSharedFields {
	archive_data_proc: string;
	autoin_recover_cp: string;
	commout_recover_cp: string;
	company_id: string;
	id: number;
	intercompany_enabled: string;
	mapper_loop_max: number;
	monitor_process_cp: string;
	san_host: string;
	san_min_interval: number;
	san_port: number;
	status_interval: number;
	template_cache_max: number;
	use_template_cache: string;
}

